import {
  Editor,
  EditorPasteEvent,
  EditorProps,
  EditorMountEvent,
  ProseMirror
} from '@progress/kendo-react-editor';
import { indent, outdent } from '@progress/kendo-editor-common';
import React from 'react';

type KendoReactEditorProps = Omit<EditorProps, 'onMount'>;

const KendoReactEditor = (props: KendoReactEditorProps) => {
  const configureEditor = (event: EditorMountEvent) => {
    const iframeDocument = event.dom.ownerDocument;
    const style = iframeDocument.createElement('style');
    style.appendChild(
      iframeDocument.createTextNode(
        'body{font-family:"Open Sans", sans-serif;font-size:13px;}'
      )
    );
    iframeDocument.head.appendChild(style);

    const tabKeymap = ProseMirror.keymap({
      Tab: (state, dispatch, view) => {
        indent(state, dispatch, view);
        return true;
      },
      'Shift-Tab': (state, dispatch, view) => {
        outdent(state, dispatch, view);
        return true;
      }
    });

    return new ProseMirror.EditorView(
      { mount: event.dom },
      {
        ...event.viewProps,
        state: event.viewProps.state.reconfigure({
          plugins: [
            ...event.plugins,
            tabKeymap,
            ProseMirror.keymap(event.shortcuts),
            ProseMirror.keymap(ProseMirror.baseKeymap)
          ]
        })
      }
    );
  };

  const preventPastingImages = (event: EditorPasteEvent) => {
    if (event.pastedHtml?.indexOf('<img') !== -1) {
      return '';
    }
  };
  return (
    <div className="kendo-react-editor">
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <Editor
        tools={props.tools}
        defaultContent={props.defaultContent}
        onChange={props.onChange}
        onMount={configureEditor}
        resizable={props.resizable}
        contentStyle={props.contentStyle}
        style={props.style}
        onPasteHtml={preventPastingImages}
      />
    </div>
  );
};

export default KendoReactEditor;

export type {
  EditorChangeEvent,
  EditorMountEvent
} from '@progress/kendo-react-editor';

export {
  EditorTools,
  ProseMirror,
  EditorToolsSettings
} from '@progress/kendo-react-editor';
export {
  indent,
  outdent,
  applyInlineStyle
} from '@progress/kendo-editor-common';
